import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as SettingSelector from "../store/setting/selectors";
import { jwtDecode } from "jwt-decode";
import { roleTypes } from "../data/roleType";

const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
};

const PermissionWrapper = ({
  permissionKey,
  actionKeys,
  permissionsList,
  allowedRoles,
  children,
  fallbackRoute = "/dashboard",
}) => {
  const navigate = useNavigate();
  const permissions = useSelector(SettingSelector.set_permissions);
  const token = localStorage.getItem("coyote-token");
  const decodedToken = decodeToken(token);

  const isSuperAdmin = decodedToken?.user?.roles?.some(
    (userRole) => userRole.role_type === roleTypes.SUPER_ADMIN
  );

  const isAdmin = decodedToken?.user?.roles?.some(
    (userRole) => userRole.role_type === roleTypes.ADMIN
  );

  const userRoles =
    decodedToken?.user?.roles?.map((role) => role.role_type) || [];

  const hasRoleAccess =
    !allowedRoles ||
    allowedRoles.some((allowedRole) => userRoles.includes(allowedRole));

  const permissionSets =
    permissionsList ||
    (permissionKey
      ? [
          {
            permissionKey,
            actionKeys: Array.isArray(actionKeys) ? actionKeys : [actionKeys],
          },
        ]
      : []);

  const hasPermissionAccess =
    isSuperAdmin ||
    permissionSets.length === 0 ||
    permissionSets.some(({ permissionKey, actionKeys }) =>
      actionKeys.some((action) => permissions?.[permissionKey]?.[action])
    );

  const hasAccess = hasRoleAccess && hasPermissionAccess;

  useEffect(() => {
    if (!hasAccess) {
      navigate(fallbackRoute);
    }
  }, [hasAccess, navigate, fallbackRoute, hasRoleAccess, hasPermissionAccess]);

  if (!permissions && permissionSets.length > 0 && !isSuperAdmin) {
    return <div>Loading permissions...</div>;
  }

  return hasAccess ? children : null;
};

export default PermissionWrapper;
